<template>
  <div class="card-padding">
    <div class="top">
      <div class="left">
        <div class="header-common view-flex view-flex-bottom">
          <div class="main">
            月度收入分析
          </div>
        </div>
        <div class="header-common view-flex view-flex-bottom">
          <div class="subtitle">
            当月累计到当月前一日收入与去年同期相比、与上月环比
          </div>
        </div>
      </div>
      <div class="right">
        <el-select
          v-model="value"
          placeholder="按销售渠道分析"
          @change="selectChanged"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>

    <br>
    <div class="mid">
      <div class="body view-flex">
        <div class="col">
          <div class="labelDisplay">
            <div class="moneyValue">
              <div class="symbol">
                <span>销售实付收入(元)&nbsp;</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div slot="content">
                    <div class="tip-content">
                      当月销售订单实付金额（减去运费，微信代金券）
                    </div>
                  </div>
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
              </div>
            </div>
            <div class="label">
              {{ money(topData && topData.this_month) || 0 }}元
            </div>
          </div>
        </div>
        <div class="col">
          <div class="labelDisplay">
            <div class="moneyValue">
              <div class="symbol">
                <span>上月销售实付收入(元)&nbsp;</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div slot="content">
                    <div class="tip-content">
                      当月的上月销售订单实付金额（减去运费，微信代金券）
                    </div>
                  </div>
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
              </div>
            </div>
            <div class="label">
              {{ money(topData && topData.last_month) || 0 }}元
            </div>
          </div>
        </div>
        <div class="col">
          <div class="labelDisplay">
            <div class="moneyValue">
              <div class="symbol">
                <span>环比&nbsp;</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div slot="content">
                    <div class="tip-content">
                      当月销售订单实付累计金额与上月销售订单实付累计金额比较增减幅度
                    </div>
                  </div>
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
              </div>
            </div>
            <div class="label">
              {{ topData.chain_ratio || 0 }}%
            </div>
          </div>
        </div>
        <div class="col">
          <div class="labelDisplay">
            <div class="moneyValue">
              <div class="symbol">
                <span>去年同期(元)&nbsp;</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div slot="content">
                    <div class="tip-content">
                      去年相同月销售订单实付累计金额（减去运费，微信代金券）
                    </div>
                  </div>
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
              </div>
            </div>
            <div class="label">
              {{ money(topData && topData.last_year) || 0 }}元
            </div>
          </div>
        </div>
        <div class="col">
          <div class="labelDisplay last">
            <div class="moneyValue">
              <div class="symbol">
                <span>同比&nbsp;</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <div slot="content">
                    <div class="tip-content">
                      当月销售订单实付累计金额与去年同期销售订单实付累计金额比较增减幅度
                    </div>
                  </div>
                  <i class="el-icon-warning-outline" />
                </el-tooltip>
              </div>
            </div>
            <div class="label">
              {{ topData.year_on_year || 0 }}%
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <el-row>
      <div id="container2" />
    </el-row>
  </div>
</template>

<script>
import { Chart } from '@antv/g2'
export default {
  data () {
    return {
      options: [
        {
          value: 'account',
          label: '全部'
        },
        {
          value: 'staff',
          label: '导购'
        },
        {
          value: 'non_staff',
          label: '编外'
        }
      ],
      value: 'account',
      chart: null,
      incomeAnalysisData: {},
      topData: {}
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    money (num) {
      return `${(num / 100).toFixed(2)}`
    },
    async fetch () {
      const data2 = await this.$api.dashboard.getIncomeAnalysis({ source_type: this.value })
      const constLineData = []
      // console.log('data2',data2)
      if (data2) {
        this.topData = data2.data
        this.incomeAnalysisData = data2.list
        let max = 0,
          ls = data2.list.length
        data2.list.forEach((d) => {
          constLineData.push({
            statistic_day: d.statistic_day,
            value: Number(this.money(d.this_month)),
            type: '本月'
          })
          constLineData.push({
            statistic_day: d.statistic_day,
            value: Number(this.money(d.last_month)),
            type: '上月'
          })
          constLineData.push({
            statistic_day: d.statistic_day,
            value: Number(this.money(d.last_year)),
            type: '去年同期'
          })
        })
        // max = this.money(Math.max(...constLineData))
        // console.log('constLineData',constLineData)
        // console.log('max',max)
        // this.incomeAnalysisData = this.incomeAnalysisData.map((v,idx) => {
        //   const _lm = Number(this.money(v.last_month)), _ly = Number(this.money(v.last_year)), _tm = Number(this.money(v.this_month));
        //   v.last_month =    _lm //_lm ? (max/_lm/100).toFixed(2) : _lm
        //   v.last_year =  _ly // _ly? (max/_ly/100).toFixed(2) : _ly
        //   v.this_month =  _tm // _tm? (max/_tm/100).toFixed(2) : _tm
        //   v.baseAxisY = idx!=ls-1?0:max
        //   return v
        // })
        this.incomeAnalysisData = constLineData
        // console.log('this.incomeAnalysisData',this.incomeAnalysisData)
        this.draw()
      }
    },
    draw () {
      if (this.chart) {
        this.chart.changeData(this.incomeAnalysisData)
      } else {
        this.chart = new Chart({
          container: 'container2',
          autoFit: true,
          height: 360
        })
        this.chart.data(this.incomeAnalysisData)
        // this.chart.legend({
        //   custom: true,
        //   items: [
        //     {
        //       value: 'last_month',
        //       name: '上月',
        //       marker: { symbol: 'hyphen', style: { stroke: '#FC5C33', r: 5, lineWidth: 3 } }
        //     },
        //     {
        //       value: 'this_month',
        //       name: '本月',
        //       marker: { symbol: 'square', style: { fill: '#429CF9', r: 5 } }
        //     },

        //     {
        //       value: 'last_year',
        //       name: '去年同期',
        //       marker: { symbol: 'hyphen', style: { stroke: '#78DCB0', r: 5, lineWidth: 3 } }
        //     }
        //   ]
        // })
        // this.chart.axis('last_year', {
        //   grid: null,
        //   title: null,
        //   label: null
        // })
        // this.chart.axis('this_month', {
        //   title: null,
        //   grid: null,
        //   label: null
        // })
        // this.chart.axis('last_month', {
        //   title: null,
        //   grid: null,
        //   label: null
        // })
        // this.chart.tooltip({
        //   shared: true
        // })
        this.chart.scale('this_month', {
          type: 'linear',
          tickInterval: 1
        })
        this.chart.scale('last_month', {
          alias: '上月'
        })
        this.chart.scale('last_year', {
          alias: '去年同期'
        })
        this.chart.legend({
          custom: true,
          items: [
            {
              value: '本月',
              name: '本月',
              marker: { symbol: 'square', style: { fill: '#429CF9', r: 5 } }
            },
            {
              value: '上月',
              name: '上月',
              marker: { symbol: 'square', style: { fill: '#57D59F', r: 5 } }
            },
            {
              value: '去年同期',
              name: '去年同期',
              marker: { symbol: 'square', style: { fill: '#5e7191', r: 5 } }
            }
          ]
        })
        this.chart.tooltip({
          showCrosshairs: true,
          shared: true
        })

        // this.chart.area().position('statistic_day*value').color('type')
        this.chart.line().position('statistic_day*value').color('type')

        // this.chart.interval().position('statistic_day*this_month').color('#429CF9')
        // this.chart.line().position('statistic_day*last_month').color('#FC5C33').size(3)
        // this.chart.line().position('statistic_day*last_year').color('#78DCB0').size(3)

        this.chart.interaction('active-region')
        this.chart.removeInteraction('legend-filter') // 自定义图例，移除默认的分类图例筛选交互
        this.chart.render()
      }
    },
    selectChanged () {
      this.fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
.card-padding {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  .body {
    display: flex;
    padding: 10px;
    .col {
      width: 33.3333%;
      margin-top: 30px;
    }
  }

  &.height190px {
    height: 190px;
  }

  .header-common {
    .main {
      font-size: 16px;
      color: black;
      font-weight: 500;
    }
    .subtitle {
      font-size: 12px;
      color: grey;
      cursor: pointer;
    }
  }
  &.histogram {
    .main {
      font-size: 16px;
      color: black;
      font-weight: 500;
    }
    .sub {
      font-size: 12px;
      color: grey;
    }
    .body {
      margin-top: 36px;
    }
  }
}
@media only screen and (max-width: 1600px) {
  .card-padding {
    padding-bottom: 30px;

    .body {
      display: flex;

      .col {
        margin-top: 20px;
      }
    }

    .header-common {
      .main {
        font-size: 14px;
      }
      .subtitle {
        font-size: 12px;
      }
    }
  }
}
.top {
  display: flex;
  justify-content: space-between;
}
.tip-content {
  max-width: 250px;
  line-height: 18px;
}

@mixin afterelement {
  position: relative;
  &:after {
    position: absolute;
    display: block;
    content: '';
    height: 340%;
    right: 10px;
    top: -15px;
    width: 1px;
    background: rgba(0, 0, 0, 0.1);
  }
}
@mixin clearafterelement {
  &:after {
    display: none;
  }
}
.labelDisplay {
  .num,
  .moneyValue {
    font-size: 24px;
    color: black;
  }
  .num {
    @include afterelement();
  }
  .label {
    font-size: 16px;
    color: #333;
  }
  .moneyValue {
    display: flex;
    align-items: flex-end;
    @include afterelement();

    .symbol {
      color: #9c9fa6;
      margin-right: 4px;
      font-size: 12px;
      position: relative;
      bottom: 4px;
    }
  }

  &.moneyLabel {
    .num {
      color: black;
    }
  }
  &.last {
    .num {
      @include clearafterelement();
    }
    .moneyValue {
      @include clearafterelement();
    }
  }
}
@media only screen and (max-width: 1600px) {
  .labelDisplay {
    .num,
    .moneyValue {
      font-size: 20px;
      color: black;
    }
    .label,
    .moneyLabel {
      font-size: 16px;
      color: #333;
    }

    .moneyValue {
      .symbol {
        color: #9c9fa6;
        margin-right: 4px;
        font-size: 12px;
        position: relative;
        bottom: 4px;
      }
    }
  }
}
</style>
